export const toESTDateString = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  // Convert to EST (UTC-5)
  const estDate = new Date(date.getTime() + (5 * 60 * 60 * 1000));
  return estDate.toISOString().split('T')[0];
};

export const formatDateForDisplay = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  // Convert to EST (UTC-5)
  const estDate = new Date(date.getTime() + (5 * 60 * 60 * 1000));
  return estDate.toLocaleDateString('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
}; 